<template>
  <div class="hot_list">
    <van-action-sheet v-model="show" class="hot_sheet">
      <!-- <div class="hot_top">
        <div class="hot_top_con">
            <div class="con_top">
              <img src="https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3170379310,1742401393&amp;fm=111&amp;gp=0.jpg">
              <div class="con_top_text">
                <p class="comp_name">北京恩盛众成国际贸易有限责任公司责</p>
                <p class="copm_address">7号馆7H52-7H531231</p>
              </div>
            </div>
            <p class="pro_type">护肤品/祛痘/祛斑/美白/健康养生</p>
            <img src="http://img4.imgtn.bdimg.com/it/u=1036422897,2513239201&fm=26&gp=0.jpg">
        </div>
        <div class="hot_top_con">
            <div class="con_top">
              <img src="https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3170379310,1742401393&amp;fm=111&amp;gp=0.jpg">
              <div class="con_top_text">
                <p class="comp_name"> <span class="hot_tag bule">品牌</span>北京恩盛众成国际贸易有限责任公司责</p>
                <p class="copm_address">7号馆7H52-7H531231</p>
              </div>
            </div>
            <p class="pro_type">护肤品/祛痘/祛斑/美白/健康养生</p>
            <img src="http://img4.imgtn.bdimg.com/it/u=1036422897,2513239201&fm=26&gp=0.jpg">
        </div>
      </div> -->
      <div class="hot_title "><img src="@/assets/img/live/huo.png" >热榜排行
      <!--<span @click="rule">规则</span>-->
      </div>
      <van-list
        class="hot_content"
        v-model="Loading"
        :finished="Finished"
        finished-text="没有更多了"
        @load="loadMore"
        :offset="50"
      >
        <div style="padding-top: 0.9rem">
        <div class="hot_item" v-for="(item,index) in hotList" :key="index" @click="linkTo(item)" >
          <img :src="item.targetInfo.logo"  v-if="item.targetInfo.logo" v-load="'oHallMarket'"style="align-items: center">
          <img src="@/assets/img/empty.png"  v-else>
          <!-- <img :src="index%2==0?'http://img4.imgtn.bdimg.com/it/u=3132973866,329395852&fm=26&gp=0.jpg':'http://img5.imgtn.bdimg.com/it/u=405815276,3463257237&fm=11&gp=0.jpg'"> -->
          <div class="comp_info">
            <div class="comp_title">
                <div  >
                  <span class="hot_tag bule" v-if="item.typeId == 0">品牌</span>
                  <span class="hot_tag red" v-if="item.typeId == 1">产品</span>
                </div>
                <p class="comp_targetInfo">{{item.targetInfo.name}}</p>

            </div>
            <p style="overflow: hidden;white-space:nowrap;text-overflow:ellipsis">{{item.targetInfo.name}}</p>
            <div class="heat_val clear" style="vertical-align: middle">

              <i class="icon iconfont icon-fenxiang2" style="display:inline-block"></i>
              <span style=" display:inline-block">{{getCount(item.shareCount)}}</span>
              <van-icon name="eye-o" style="display:inline-block"/>
              <span style="display:inline-block">{{getCount(item.viewCount)}}</span>
            </div>
          </div>
          <div class="help_info">
            <div class="info_img">
              <template v-for="(item,index) in item.userInfos.slice(0,3)">
                <img :src="item.avatarUrl" v-if="item.avatarUrl" :key="'i'+index"/>
                <img src="@/assets/img/empty.png" v-else :key="'i'+index"/>
              </template>
            </div>
            <p style="text-align: center">{{getCount(item.userCount)}}人浏览</p>
          </div>
        </div>
        </div>
      </van-list>
      <van-popup class="rule_pop" v-model="ruleShow" closeable>
        <div class="rule_title">规则</div>
        <div class="con">
          <div class="con_text">
            规则内容规则内容规则内容规则则内容规则内容规则内容规则则内容规则内容规则内容规则则内容规则内容规则内容规则则内容规则内容规则内容规则则内容规则内容规则内容规则则内容规则内容规则内容规则则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内容规则内
          </div>
        </div>
      </van-popup>
      <div >
      </div>
    </van-action-sheet>
    <hotHelp ref='hotHelp'></hotHelp>
  </div>
</template>

<script>
import hotHelp from "@components/hot-help";
import { mapGetters, mapActions } from "vuex";
export default {
  // 热榜
  name: "hot-list",
  data() {
    return { 
      show: false,           //是否显示助力排行榜
      ruleShow:false,        //规则
      Loading: false, //加载状态
      Finished: false, //加载是否完成状态
      hotList:[],           //助力排行列表
      pageSize: 6,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0
    };
  },
  components: {
    hotHelp
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userInfo: "getUserInfo",
      roomId:"getRoomid"
    }),
    option() {
      return {
        roomId: this.roomId,
        page: this.pageIndex,
        size: this.pageSize,
        userNum: 3
      };
    }
  },
  methods: {
    ...mapActions({
      getHotList:'company/getHotList',
      LinkProduct:'linkTo/LinkProduct',
      LinkCompany:'linkTo/LinkCompany',
      LinkExhibitionDetails:'linkTo/LinkExhibitionDetails',
      addhotViewer:'company/addhotViewer',
      LinkHotProduct:'linkTo/LinkHotProduct',
      LinkHotExhibitionDetails:'linkTo/LinkHotExhibitionDetails'
    }),
    async init() {
      this.Loading = true;
      setTimeout(() => {
        this.Loading = false;
      }, 5000);
      const req = {};
      const list = await this.getHotList(this.option);
      if (list.code && !list.result) {
        this.Loading = false;
        this.Finished = true;
        return;
      }
      if(list.items && list.items.length){
        list.items.map(c => {
          if(c.targetInfo){
            c.targetInfo = JSON.parse(c.targetInfo)
          }
          if(c.userInfos.length){
            let arr =[];
            c.userInfos.map(v=>{
              if(v.indexOf("{") !== -1){
                v = JSON.parse(v);
                arr.push(v);
              }
            })
            c.userInfos = arr;
          }
        });
        this.hotList.push(...list.items);
      }
      console.log(this.hotList,'this.hotList');
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
      this.totalPages = list.totalPages;
      this.Loading = false;
      if (this.totalCount <= this.hotList.length) {
        this.Finished = true;
      }
      // if(list.hasNextPage){
      //   this.Finished = true;
      // }
      console.log(this.Finished,'this.Finished');
    },
    open(){
      this.pageIndex = 1;
      this.Loading=true;
      this.Finished=false;
      this.hotList=[];
      this.show=true;
      this.init();
    },
    //加载更多排行榜数据
    loadMore(){
      if (this.Finished) return;
      this.pageIndex = this.pageIndex + 1;
      this.init();
    },
    linkTo(item){
      if(this.userInfo.userRole == 0){ // 游客身份不给进
         this.$toast('请前往注册');
         return;
      }
      if(item.typeId === 1) { // 展品
        this.LinkHotProduct({id:item.targetId,hotId:item.id});
      }
      if(item.typeId === 0) { // 展商公司
        this.LinkHotExhibitionDetails({id:item.targetId,hotId:item.id});
      }
      let userInfo = {name:this.userInfo.name || this.userInfo.nickName ,avatarUrl:this.userInfo.avatarUrl}
      let body = {
            popularzeId: item.id,
            userId: this.userInfo.userId,
            userInfo: JSON.stringify(userInfo),
            fromType: 2,  // 热榜
          }
      this.addhotViewer(body);
      console.log(body,'addhotViewer');
    },
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
    //助力上榜点击
    helpClick(){
      this.$refs.hotHelp.open();
    },
    //点击规则
    rule(){
      this.ruleShow=true; 
    }
  }
};
</script>

<style scoped lang="scss">
.clear::after,
.clear::before {
  content: "";
  display: block;
  clear: both;
}
.hot_tag{
  /*line-height: 0.24rem;*/
  /*height: 0.24rem;*/
  font-size: 0.18rem;
  padding: 0.03rem 0.08rem;
  border-radius: 0.03rem;
  display: inline-block;
  &.bule{
    background: #d4e9ff;
    color:#2792ff;
  }
  &.yellow{
    background: #ffe4d1;
    color: #ff761b;
  }
  &.red{
    background: #ffd9d9;
    color: #ff3f3f;
  }
}
.hot_list{
  .hot_sheet{
    height: 10.5rem;
    border-radius: 0.16rem 0.16rem 0 0;
    padding:0 3%;
    .hot_top{
      display: flex;
      justify-content: space-between;
      padding-bottom: 0.29rem;
      border-bottom: 1px solid #f2f2f2;
      .hot_top_con{
        padding: 0.1rem 0.1rem 0.23rem;
        border-radius: 0.03rem;
        width: 3.4rem;
        position: relative;
        overflow: hidden;
        color:#fff;
        .con_top{
          display: flex;
          margin-bottom: 0.2rem;
          img{
            width: 1.08rem;
            height: 1.08rem;
            flex-shrink:0;
            // object-fit: cover;
            border-radius: 0.03rem;
            display: block;
            margin-right: 0.1rem;
          }
          .con_top_text{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow:hidden;
            padding-top: 0.04rem;
            p{
              line-height: 0.3rem;
            }
            .comp_name{
              white-space: initial;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .copm_address{
              display:block;
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
            }
          }
        }
        .pro_type{
          font-size: 0.2rem;
          line-height: 1;
          display:block;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
        >img{
          width: 100%;
          height: 100%;
          // object-fit: cover;
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
          filter: blur(0.06rem); 
        }
      }
    }
    .hot_title{
      height: 0.9rem;
      line-height: 0.9rem;
      background:url("../../assets/img/schedule_title.png");
      background-size: 100% 100%;
      font-size: 0.26rem;
      color:#333;
      text-align: center;
      letter-spacing: 0.03rem;
      padding-left: 0.03rem;
      position: fixed;
      z-index: 10000;
      width: 94%;
      img{
        width: 0.24rem;
        height: 0.28rem;
        margin-right: 0.1rem;
        transform: translateY(0.03rem);
      }
      span{
        color:#666;
        font-size: 0.18rem;
        float: right;
      }
    }
    .hot_content{
      .hot_item{
        margin-top: 0.15rem;
        padding-bottom: 0.15rem;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        align-items: center;
        &:first-child{
          >img{
            border-color:#ffe26d;
          }
        }
        &:nth-child(2){
          >img{
            border-color:#f2f2f2;
          }
        }
        &:nth-child(3){
          >img{
            border-color:#ffbe8f;
          }
        }
        >img{
          width: 1.2rem;
          height: 1.2rem;
          // object-fit: cover;
          display: block;
          border: 1px solid #d9d9d9;
          border-radius: 0.03rem;
          margin-right: 0.19rem;
        }
        .comp_info{
          padding-top: 0.13rem;
          width: 60%;
          p{
            /*line-height: 1;*/
            &:nth-child(2){
              /*margin-bottom: 0.12rem;*/
              font-size: 0.24rem;
              color: #666;
            }
          }
          .comp_title{
            color: #333;
            margin-bottom: 0.15rem;
            display: flex;
            align-items: center;
            .comp_targetInfo{
            margin-left: 0.1rem;
              width: 70%;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap

          }
          }
          .heat_val{
            margin-left: -0.03rem;
            margin-top: 0.1rem;
            color:#999;
            vertical-align: text-bottom;
            .icon,.van-icon{

              font-size: 0.3rem;
              float: left;
              transform: translateY(-0.05rem);
            }
            .van-icon{
              margin-right: 0.04rem;
              transform: translateY(-0.04rem);
            }
            span{
              float: left;
              font-size: 0.2rem;
              margin-right: 0.2rem;
            }
          }
        }
        .help_info{
          margin-left: auto;
          padding: 0.2rem 0;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .info_img{
            width: 1.02rem;
            height: 0.42rem;
            display: flex;
            img{
              width: 0.42rem;
              height: 0.42rem;
              border-radius: 50%;
              border: 1px solid #fff;
              // object-fit: cover;
              &:nth-child(1){
                position: relative;
                z-index: 3;
              }
              &:nth-child(2){
                position: relative;
                z-index: 2;
                margin-left: -0.13rem;
              }
              &:nth-child(3){
                position: relative;
                z-index: 1;
                margin-left: -0.13rem;
              }
            }
          }
          p{
            font-size: 0.2rem;
          }
          
          //助力样式↓↓↓
          // margin-left: auto;
          // display: flex;
          // justify-content: space-between;
          // flex-direction: column;
          // padding: 0.1rem 0 0.03rem;
          // p{
          //   // color: #e53935;
          //   background-image: -webkit-gradient(linear, left 0, right 0, from( #e53935), to(#e35d5b));
          //   -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
          //   -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
       
          // }
          // img{
          //   width: 0.45rem;
          //   margin: 0 auto;
          //   display: block;
          // }
        }
      }
    }
  }
  &::v-deep .rule_pop{
    width: 5.6rem;
    height: 5.36rem;
    border-radius: 0.08rem;
    transform: translate(-50%,-50%);
    overflow: hidden;
    color: #333;
    .van-popup__close-icon--top-right{
      right: 0.2rem;
      top: 0.23rem;
      font-size: 0.44rem;
      color: #333;
      
    }
    .rule_title{
      font-size: 0.36rem;
      height:0.94rem;
      line-height: 0.94rem;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
    }
    .con{
      line-height: 0.36rem;
      height: 4.16rem;
      overflow-y: auto;
      .con_text{
        text-align: justify;
        padding: 0.17rem 0.3rem 0;
        vertical-align: top;
      }
    }
  }
}
</style>
